export default __webpack_public_path__ + "static/media/home.315f29b1.svg";